/**
 * Vehicle page gallery: scroll-snap slides per tab (exterior / interior / photos),
 * prev/next buttons, thumbnails and a <dialog> lightbox.
 */
export function initVehicleGallery() {
    const root = document.querySelector('[data-vehicle-gallery]');
    if (!root) {
        return;
    }
    const lightbox = document.getElementById('ui-lightbox');
    const lightboxImg = lightbox?.querySelector('img');

    const panels = [...root.querySelectorAll('[data-gallery-panel]')];
    const tabs = [...root.querySelectorAll('[data-gallery-tab]')];

    panels.forEach((panel) => {
        const track = panel.querySelector('[data-gallery-track]');
        const slides = [...track.children];
        const thumbs = [...panel.querySelectorAll('[data-gallery-thumb]')];
        const counter = panel.querySelector('[data-gallery-count]');
        let index = 0;

        const go = (i) => {
            index = (i + slides.length) % slides.length;
            track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
        };
        const sync = () => {
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            index = Math.min(slides.length - 1, Math.max(0, i));
            thumbs.forEach((thumb, t) => thumb.classList.toggle('is-active', t === index));
            if (counter) {
                counter.textContent = `${index + 1} / ${slides.length}`;
            }
        };

        panel.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(index - 1));
        panel.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(index + 1));
        thumbs.forEach((thumb, t) => thumb.addEventListener('click', () => go(t)));
        track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
        track.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') { go(index + 1); }
            if (event.key === 'ArrowLeft') { go(index - 1); }
        });

        slides.forEach((slide) => slide.querySelector('img')?.addEventListener('click', (event) => {
            if (!lightbox || typeof lightbox.showModal !== 'function') {
                return;
            }
            lightboxImg.src = event.currentTarget.dataset.full || event.currentTarget.currentSrc || event.currentTarget.src;
            lightboxImg.alt = event.currentTarget.alt;
            lightbox.showModal();
        }));
        sync();
    });

    tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
        panels.forEach((panel) => { panel.hidden = panel.dataset.galleryPanel !== tab.dataset.galleryTab; });
    }));

    lightbox?.querySelector('[data-close]')?.addEventListener('click', () => lightbox.close());
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) { lightbox.close(); } });
}
